<template>
    <v-text-field
        dense
        flat
        hide-details
        rounded
        clearable
        append-icon="mdi-magnify"
        :placeholder="placeholder"
        ref="search"
        solo-inverted
        v-model.trim="searchText"
        data-testid="sms-search-field"
        @focus="searchBoxClosed = false"
        @blur="searchBoxClosed = true"
        class="expanding-search"
        :class="{ closed: searchBoxClosed && !searchText }"
    ></v-text-field>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'chat-room-search',
  data: () => ({
    searchBoxClosed: true
  }),
  computed: {
    ...mapGetters({
      getSmsSearchText: 'chat/SmsFilters/search',
      getDmSearchText: 'chat/DmFilters/search',
      getChannelsSearchText: 'chat/ChannelsFilters/search',
      getGroupsSearchText: 'chat/GroupsFilters/search'
    }),
    getSearch () {
      if (this.isSms) {
        return this.getSmsSearchText
      } else if (this.isDm) {
        return this.getDmSearchText
      } else if (this.isChannel) {
        return this.getChannelsSearchText
      } else if (this.isGroup) {
        return this.getGroupsSearchText
      }
      return ''
    },
    searchText: {
      get () { return this.getSearch },
      set (searchText) { this.performSearch(searchText) }
    },
    placeholder () {
      return this.$t('chat.search')
    }
  },
  props: {
    isChannel: {
      type: Boolean,
      default: false
    },
    isGroup: {
      type: Boolean,
      default: false
    },
    isDm: {
      type: Boolean,
      default: false
    },
    isSms: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions({
      setSmsSearchText: 'chat/SmsFilters/setSearch',
      setDmSearchText: 'chat/DmFilters/setSearch',
      setChannelsSearchText: 'chat/ChannelsFilters/setSearch',
      setGroupsSearchText: 'chat/GroupsFilters/setSearch'
    }),
    performSearch (search) {
      if (this.isSms) {
        this.setSmsSearchText(search)
      } else if (this.isDm) {
        this.setDmSearchText(search)
      } else if (this.isChannel) {
        this.setChannelsSearchText(search)
      } else if (this.isGroup) {
        this.setGroupsSearchText(search)
      }
    }
  }
}
</script>

<style lang="sass">
  .v-input.expanding-search
    transition: max-width 0.5s
    .v-input__slot
    max-width: 250px
    &.closed
      max-width: 70px
</style>
